import usePromise from "../hooks/usePromise";
import { getUserCourseProgress } from "../../libs/courses";
import Panel from "../core/Panel";
import * as React from "react";
import ProgressBar from "../core/ProgressBar";

function CourseAssignment({ course, user }) {
  const [progress, { loading: loadingProgress }] = usePromise(
    () => getUserCourseProgress(course.id, user.id),
    []
  );

  return (
    <Panel>
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h5>{course.title}</h5>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <a href={course.links.url} className={"btn btn-info"}>
              View Course
            </a>
          </div>
        </div>
      </div>
      <div className="level">
        <div className="level-item">
          <ProgressBar
            type={progress === 100 ? "success" : "info"}
            progress={progress || 0}
          >
            {progress || 0}%
          </ProgressBar>
        </div>
      </div>
    </Panel>
  );
}

export default CourseAssignment;



// WEBPACK FOOTER //
// ./app/javascript/components/courses/CourseAssignment.tsx